<template>
  <div class="image-multi">
    <ul class="image-multi__list">
      <li class="image-multi__item" :draggable="true" @dragstart="dragStart(index)" @dragenter="dragEnter(index)" @dragend.stop.prevent="dragEnd" @dragover.stop.prevent="dragOver" v-bind:key="index" v-for="(data, index) in dataList">
        <img :src="data">
        <input type="hidden" :name="dataModel + '[' + dataColumn + '][' + index + ']'" :value="data">
        <span v-if="isUploadedImage(data)" class="image-multi__delete-button" @click="deleteLine(index)">✕</span>
      </li>
      <li class="image-multi__item-add">
        <label for="ImageGalleryFileInput" @drop="upload($event)">
          画像をドラッグ＆ドロップ<br>または<br>クリックして画像を選択<br>（jpg形式・2MB未満）
        </label>
      </li>
    </ul>
    <input class="image-multi__input" id="ImageGalleryFileInput" type="file" multiple="multiple" @change="upload($event, file, index)" />
  </div>
</template>

<script>
import { defineComponent } from "vue";
import axios from "axios";

export default defineComponent({
  data() {
    return {
      dataList: [],
      dataModel: null,
      dataColumn: null,
      draggingIndex: null,
    };
  },
  mounted() {
    const dataElement = this.$el.parentElement;

    this.dataList = JSON.parse(dataElement.dataset.value);

    if (this.dataList == null) {
      this.dataList = [];
    }

    this.dataModel = dataElement.dataset.model;
    this.dataColumn = dataElement.dataset.column;
  },
  methods: {
    upload: async function (event) {
      const config = {
        headers: {
          "content-type": "multipart/form-data",
        },
      };

      const fileList = event.target.files ?? event.dataTransfer.files;

      let formData = new FormData();
      Object.keys(fileList).map((index) => {
        formData.append("upfile[" + index + "]", fileList[index]);
      });

      axios
        .post("/file/upload_image_multi", formData, config)
        .then((response) => {
          if (response.data.status == "OK") {
            response.data.urlList.forEach((file) => {
              this.dataList.push(file);
            });
          } else {
            alert(response.data.message);
          }
        })
        .catch((response) => {
          alert(
            "ファイルアップロード時にエラーが発生しました。管理者にお問い合わせください。"
          );
        });
    },
    deleteLine: async function (index) {
      this.dataList = this.dataList.filter((data, i) => {
        return i !== index;
      });
    },
    addLine: async function () {
      this.dataList.push({ code: "", text: "" });
    },
    dragStart: async function (index, e) {
      this.draggingIndex = index;
    },
    dragEnter: async function (index) {
      if (index === this.draggingIndex) return;

      const deleteElement = this.dataList.splice(this.draggingIndex, 1)[0];
      this.dataList.splice(index, 0, deleteElement);
      this.draggingIndex = index;
    },
    dragOver: async function (e) {},
    dragEnd: async function (e) {
      this.draggingIndex = null;
    },
    isUploadedImage: function (image) {
      return (
        image != "/img/product-main-image.png" &&
        image != "/img/product-detail-image.png"
      );
    },
  },
});
</script>